






























import { Features } from "@/types/settings";
import { Component, Vue, Watch } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component
export default class PromoBanner extends Vue {
  created() {
    // If cookie is not set, show the promo banner
    if (!document.cookie.split(";").some(item => item.trim().startsWith("promoBannerDismissed="))) {
      this.$store.dispatch("setPromoBannerDismissed", false);
    }
  }

  @State("promoBannerDismissed") promoBannerDismissed!: boolean;

  @Getter("settings/activeCacheFeatures") features!: Features;

  // route changes are not reactive, so watch for changes
  @Watch("$route")
  onRouteUpdate() {
    this.checkIsConsultingView();
  }

  isConsultingView = false;

  dismissPromoBanner() {
    document.cookie = "promoBannerDismissed=true";
    this.$store.dispatch("setPromoBannerDismissed", true);
  }

  checkIsConsultingView() {
    if (this.$router.currentRoute.name === "consulting") {
      this.isConsultingView = true;
    } else {
      this.isConsultingView = false;
    }
  }
}
